interface CsvContentRow {
  columns: string[];
}

/** Join CSV rows into text using the given delimiter (preserves the delimiter detected on upload). */
export function buildCsvContent(rows: CsvContentRow[], delimiter: string): string {
  return rows.map(row => row.columns.join(delimiter)).join('\n');
}
